import { render, staticRenderFns } from "./PublicPage.vue?vue&type=template&id=608d1bfd&scoped=true&"
import script from "./PublicPage.vue?vue&type=script&lang=js&"
export * from "./PublicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d1bfd",
  null
  
)

export default component.exports